module.exports = __webpack_public_path__ + "media/images/icon-keyboard-arrow-up-ca367c953b602d9a0b95d29ff611cbdf.svg";